import {
  useGetMasterDistrict,
  useGetMasterProvince,
  useGetTransportType,
  useMasterTransport,
} from "hooks/useMasterData";
import styled from "@emotion/styled";
import { Alert, Form, FormInstance, Input, Select, TimePicker } from "antd";
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import {
  MasterTransport,
  ParkingLists,
  ParkinglistInput,
  TransportationTypeItems,
  getMasterTransportByIdData,
} from "services/interface";
import DeliveryPoint from "components/DeliveryPoint/DeliveryPoint";
import TableParking from "./TableParking";
import { useAppSelector } from "store";
import { useGetTransportationTypeByFactory } from "hooks/useFactory";
const { Option } = Select;

interface TransportationDescriptionFormProps {
  is_active: boolean;
  dataType: TransportationTypeItems[] | undefined;
  form: FormInstance;
  data?: getMasterTransportByIdData;
  parkingList?: ParkingLists[];
  parkingListInput: ParkinglistInput[];
  setParkingListInput: Dispatch<SetStateAction<ParkinglistInput[]>>;
}

const TransportationDescriptionForm: FC<TransportationDescriptionFormProps> = ({
  is_active,
  dataType,
  form,
  data,
  parkingList,
  setParkingListInput,
}) => {
  const childrenTransportationType: React.ReactNode[] = [];
  childrenTransportationType.push(
    <Option key="" value="">
      เลือกประเภทการขนส่ง
    </Option>
  );

  dataType?.map((item) => {
    return childrenTransportationType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

  const [masterTransport, setMasterTransport] = useState<MasterTransport[]>([]);

  const [selectTransport, setSelectTransport] = useState<MasterTransport>();

  const [provinceIdstart, setProvinceIdstart] = useState<number>(0);

  const [provinceIdend, setProvinceIdend] = useState<number>(0);

 // const { data: masterTransportType } = useGetTransportType();

  const [search, setSearch] = useState<string>("");

  // const { data: transportData, isLoading, refetch } = useMasterTransport({
  //   search: search,
  // });

  const { data: masterTransportType } = useGetTransportationTypeByFactory(factoryId ?? "")

  const { data: masterProviceData } = useGetMasterProvince();

  const { data: masterDistrictDataStart } =
    useGetMasterDistrict(provinceIdstart);

  const { data: masterDistrictDataEnd } = useGetMasterDistrict(provinceIdend);

  useEffect(() => {
    if (data) {
      setProvinceIdstart(data.province_start_id);
      setProvinceIdend(data.province_end_id);
    }
  }, [data]);

  const childrenTransport: React.ReactNode[] = [];
  masterTransport?.map((item) => {
    childrenTransport.push(
      <Option key={item.id} value={item.id}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>
            {`${item.name}  ${item.province_name_start} - ${item.province_name_end}
             (รอบ ${item.time_start} - ${item.time_end} น.)`}
          </div>

          {/* <div>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    
                  }}
                >
                  ลบ
                </Button>
              </div> */}
        </div>
      </Option>
    );
  });

  const childrenTransportType: React.ReactNode[] = [];
  masterTransportType?.data?.map((item) => {
    return childrenTransportType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenProviceStart: React.ReactNode[] = [];
  masterProviceData?.map((item: any) => {
    return childrenProviceStart.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceEnd: React.ReactNode[] = [];
  masterProviceData?.map((item: any) => {
    return childrenProviceEnd.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  return (
    <FormWrapper>
      <Form.Item
        label="ประเภทขนส่ง"
        className="form-transport"
        name="type"
        required
        rules={[
          {
            required: true,
            message: "กรุณาเลือกประเภทขนส่ง",
          },
        ]}
      >
        <Select placeholder="เลือกประเภทขนส่ง" showSearch
          disabled={
            data ? true : false
          }
        >
          {childrenTransportType}
        </Select>
      </Form.Item>
      <Form.Item
        label="ชื่อบริษัท"
        name="transport_name"
        className="form-transport"
        required
        rules={[
          {
            required: true,
            message: "กรุณากรอกขนส่ง",
          },
        ]}
      >
        <Input size="small" placeholder="ระบุชื่อบริษัทขนส่ง" />
      </Form.Item>
      {/* <Form.Item
        label="จังหวัดต้นทาง"
        className="form-transport"
        name="province_start_id"
        
        required
        rules={[
          {
            required: true,
            message: "กรุณาเลือกจังหวัดต้นทาง",
          },
        ]}
      >
        <Select
          showSearch
          allowClear
          placeholder="เลือกจังหวัดต้นทาง"
          optionFilterProp="children"
          onSelect={(value) => {
            setProvinceIdstart(value);
            form.setFieldsValue({
              district_start_id: undefined,
            });
          }}
        >
          {childrenProviceStart}
        </Select>
      </Form.Item> */}
      {/* <Form.Item
        label="จังหวัดปลายทาง"
        className="form-transport"
        name="province_end_id"
        required
        rules={[
          {
            required: true,
            message: "กรุณาเลือกจังหวัดปลายทาง",
          },
        ]}
      >
        <Select
          placeholder="เลือกจังหวัดปลายทาง"
          optionFilterProp="children"
          allowClear
          showSearch
          onSelect={(value) => {
            setProvinceIdend(value);
            form.setFieldsValue({
              district_end_id: undefined,
            });
          }}
        >
          {childrenProviceEnd}
        </Select>
      </Form.Item> */}
      {/* <Form.Item label="รอบออกรถ" className="form-transport" name="timeStart">
        <TimePicker style={{ width: "100%" }} size="middle" format={"HH:mm"} />
      </Form.Item> */}
      
      <div>
        <TableParking 
          data={data}
          parkingList={parkingList}
          setParkingListInput={setParkingListInput}
        />
      </div>
    </FormWrapper>
  );
};

export default TransportationDescriptionForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
`;
